<script setup>
import useSessionActions from '~/composables/sessions/useSessionActions';

const props = defineProps({
    session: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['close']);
const { isSaveSeatLoading } = useSessionActions(props.session);
const route = useRoute();
const router = useRouter();

const closeModal = () => {
    emit('close');
};

const viewSavedSeats = () => {
    const link = `/agenda?view=saved`;
    navigateTo(link, { external: true, replace: true });
};
</script>

<template>
    <div>
        <h2>Your seat has been saved for "{{ session.title }}" and added to My Favorites!</h2>
        <div class="modal-action-buttons">
            <ProjectButtonSecondary type="submit" :disabled="isSaveSeatLoading" :loading="isSaveSeatLoading"
                :filledIn="true" @click="viewSavedSeats">VIEW MY SAVED SEATS</ProjectButtonSecondary>
            <ProjectButtonSecondary type="submit" :disabled="isSaveSeatLoading" :loading="isSaveSeatLoading"
                @click="closeModal">Close</ProjectButtonSecondary>
        </div>
    </div>
</template>
